// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D0v_","icon":"styles_icon__3tvI-"};